<script setup lang="ts">
import i18n from '@/i18n';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, ShiftCMSState } from '@/store';
import { parseCookie } from '@/util/cookie.util';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState>();
const events = useEvents();
const lang = computed<string>(() => store.state.language);
const dirtyState = computed<boolean>(() => store.state.dirtyState);

const setLanguage = async (l: string) => {
  if (dirtyState.value) {
    alert('Save your work before changing the language');
    return;
  }

  if (lang.value !== l) {
    await store.dispatch(Actions.SetLanguage, l);
    events.emit(Event.LanguageChanged, l);
    i18n.global.locale = l as 'en' | 'nl';
  }
};

onMounted(() => {
  const cookies = parseCookie(document.cookie);

  i18n.global.locale =
    (cookies.lang as 'en' | 'nl') || (lang.value as 'en' | 'nl');
});
</script>

<template>
  <div class="filters">
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn density="compact" flat color="success" v-bind="props">{{
          lang === 'nl' ? 'NL' : 'EN'
        }}</v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title
            ><v-btn
              block
              compact
              variant="outlined"
              outlined
              @click="() => setLanguage(lang === 'nl' ? 'en' : 'nl')"
              >{{ lang === 'nl' ? 'EN' : 'NL' }}
            </v-btn></v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<style scoped>
.filters {
  position: fixed;
  display: flex;
  z-index: 150;
  right: 150px;
  top: 18px;
  width: 150px;
}
</style>
